export const phoneFields: string[] = [
   'phoneId',
   'numberOfLineKeys',
   'extensionId',
   'phoneType',
   'sipUsers',
   'devices',
   'handsetIpei',
   'baseStationHandsets',
];

export const sipUserFields: string[] = ['sipUserId', 'userName', 'hashPassword', 'accountId'];

export const deviceFields: string[] = ['deviceId'];

export const baseStationFields: string[] = ['baseStationHandsetId', 'deviceId', 'phoneId', 'sortId'];
